import * as React from 'react'
import { classnames } from '@halo/_utils/classnames'
import { isDef } from '@pushly/aqe/lib/utils/is-def'
import { PropsWithChildren } from 'react'

interface IHeader {
    left?: React.ReactNode
    right?: React.ReactNode
}

export class CompoundTableHeader extends React.PureComponent<IHeader> {
    public render() {
        return (
            <div className={classnames('compound-table-header')}>
                <div className={classnames('compound-table-header-wrapper')}>
                    {isDef(this.props.left) && (
                        <div className={classnames('compound-table-header-left')}>{this.props.left}</div>
                    )}
                    {isDef(this.props.right) && (
                        <div className={classnames('compound-table-header-right')}>{this.props.right}</div>
                    )}
                </div>
            </div>
        )
    }
}

export class CompoundTable extends React.PureComponent<PropsWithChildren<any>> {
    public render() {
        return (
            <div className={classnames('compound-table')}>
                <div className={classnames('compound-table-wrapper')}>{this.props.children}</div>
            </div>
        )
    }
}
